import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNestjsComponent } from './simple-icons-nestjs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNestjsComponent ],
    exports:      [ SimpleIconsNestjsComponent ],
    bootstrap:    []
})
export class SimpleIconsNestjsModule {}
